import Button from 'src/features/ui/components/Button/Button';
import { Card } from 'src/features/ui/components/Card/Card';
import Text from 'src/features/ui/components/Text/Text';
import styled from 'styled-components';

type TextProps = {
  margin?: string;
  textAlign?: 'center' | 'left';
};

export const Wrapper = styled.main`
  text-align: center;
  font-size: 1.6rem;
  background-color: ${({ theme }) => theme.palette.brand.backgroundMain};
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 32px;
`;

export const Logo = styled.img`
  width: 20rem;
`;

export const CreateNewPasswordCard = styled(Card)`
  padding: 3.1rem 16rem 3.7rem 16rem;
  max-width: 920px;
  background-color: ${({ theme }) => theme.palette.brand.white};
  margin: 0 auto;
`;

export const H2 = styled(Text)<TextProps>`
  margin: ${props => props?.margin ?? '0rem'};
  color: ${({ theme }) => theme.palette.brand.textPrimary};
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 3.3rem;
`;

export const H4 = styled(Text)<TextProps>`
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.palette.brand.textSecondary};
  font-size: 2rem;
  font-weight: 600;
`;

export const SubmitButton = styled(Button)`
  font-size: 2rem;
  margin: 2.8rem auto auto auto;
  padding: 0.5rem 3rem;
`;

export const ErrorMessage = styled(Text)`
  font-size: 1.75rem;
  margin-top: 1rem;
  color: ${({ theme }) => theme.palette.brand.corePPTAction};
`;

export const CentralizedDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;
